import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useMap, useMapsLibrary, MapControl, ControlPosition } from "@vis.gl/react-google-maps";

import MarkerPlace from "./MarkerPlace";
import { mapCenterChanged, mapZoomChanged, mapSetMarkerPlace, mapSelectedMarkerSearch, CLEAR_SELECTING } from "../../reducers/map";

function SearchPlace(props) {
  const map = useMap();
  const placesLib = useMapsLibrary("places");
  const inputRef = useRef(null);
  const searchBoxRef = useRef(null);

  useEffect(() => {
    if (!placesLib || !inputRef.current || searchBoxRef.current) return;
    const sb = new placesLib.SearchBox(inputRef.current);
    searchBoxRef.current = sb;

    const listener = sb.addListener("places_changed", () => {
      const places = sb.getPlaces();
      if (!places || places.length === 0) return;
      const bounds = new window.google.maps.LatLngBounds();
      let name = "";
      places.forEach((place) => {
        if (!place.geometry) return;
        if (place.geometry.viewport) bounds.union(place.geometry.viewport);
        else bounds.extend(place.geometry.location);
        name = place.name;
      });
      const position = places[0].geometry.location;
      props.mapSetMarkerPlace({ ...props.markerPlace, name, position });
      props.SET_CENTER(position);
      props.SET_ZOOM(15);
      props.CLEAR_SELECTING();
      props.mapSelectedMarkerSearch("place_id");
      if (map) map.panTo(position);
    });

    return () => { if (listener) listener.remove(); searchBoxRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placesLib, map]);

  return (
    <React.Fragment>
      <MapControl position={ControlPosition.TOP_LEFT}>
        <input
          ref={inputRef}
          type="text"
          placeholder="Search Places"
          style={{
            boxSizing: "border-box", border: "1px solid transparent", width: "300px", height: "32px",
            marginTop: "10px", marginRight: "40px", padding: "0 12px", borderRadius: "3px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)", fontSize: "14px", outline: "none", textOverflow: "ellipses",
          }}
        />
      </MapControl>
      {props.markerPlace && (
        <MarkerPlace key="place_id" id="place_id" name={props.markerPlace.name} position={props.markerPlace.position} />
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({ bounds: state.map.bounds, markerPlace: state.map.markerPlace });
const mapActionsToProps = {
  SET_CENTER: mapCenterChanged, SET_ZOOM: mapZoomChanged, mapSetMarkerPlace, mapSelectedMarkerSearch, CLEAR_SELECTING,
};
export default connect(mapStateToProps, mapActionsToProps)(SearchPlace);
